import React, { lazy, Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Loading from '../custom/Loading';

import MainWrapper from './MainWrapper';

import { CLIENT_EXPEDIENT } from '../constants/app';
import PaymentSummary from '../containers/agent/Tabs/Payments/PaymentSummary';
import ValidationUser from '../containers/client/validation';
import IdentificateUser from '../containers/client/identificate';
import ReceiptsClient from '../containers/client/receipts';
import PaymentMovements from '../containers/paymentMovements';

import RequireAuth from '../components/auth/RequireAuth';
import Callback from '../components/auth/Callback';
import LogoutSuccess from '../components/auth/LogoutSuccess';
import ProfileIncompleteError from '../components/ProfileIncompleteError';

const LogIn = lazy(() => import('../containers/login'));
const Layout = lazy(() => import('../containers/_layout'));

// [H-025] LogInSuperAdmin y Register eliminados del bundle del cliente Sura.
// ops-access y signup no deben ser accesibles para usuarios finales de Sura.
// Si se necesitan, deben vivir en un build/subdominio separado.

const DashboardsPage = lazy(() => import('../containers/dashboards'));
const CustomersPage = lazy(() => import('../containers/customers'));
const InvoicesPage = lazy(() => import('../containers/invoices'));
const ContractsPage = lazy(() => import('../containers/contracts'));
const ContractPage = lazy(() => import('../containers/contract'));
const InvoicePage = lazy(() => import('../containers/invoice'));
const PaymentsPage = lazy(() => import('../containers/payments'));
const PaymentPage = lazy(() => import('../containers/payment'));
const CustomerPage = lazy(() => import('../containers/customer'));
const CustomerPageTwo = lazy(() => import('../containers/customer/newIndex'));
const AccountPage = lazy(() => import('../containers/account'));

const PaymentPortal = lazy(() => import('../containers/paymentPortal'));
const Agent = lazy(() => import('../containers/agent'));
const Client = lazy(() => import('../containers/client'));

const Router = () => (
  <MainWrapper>
    <main>
      <Suspense fallback={<Loading center />}>
        <Switch>
          <Route path="/auth/callback" component={Callback} />
          <Route path="/logout-success" component={LogoutSuccess} />
          <Route path="/login" component={LogIn} />
          {/* [H-025] /signup y /ops-access eliminados — no deben estar disponibles
              en el portal del cliente Sura. Ver bugfix/h025-remove-ops-signup-routes */}
          <Route path="/profile-incomplete-error" component={ProfileIncompleteError} />
          <Route path="/cobranza" component={PaymentLayout} />

          <Route
            path="/app"
            render={() => (
              <RequireAuth>
                <AppLayout />
              </RequireAuth>
            )}
          />

          <Route
            path="/account"
            render={() => (
              <RequireAuth>
                <AppLayout />
              </RequireAuth>
            )}
          />

          <Redirect to="/login" />
        </Switch>
      </Suspense>
    </main>
  </MainWrapper>
);

const PaymentLayout = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <div className="container__wrap container_payment">
        <Suspense fallback={<Loading center />}>
          <Switch>
            <Route exact path="/cobranza" component={PaymentPortal} />
            <Route path="/cobranza/agente" component={Agent} />
            <Route path="/cobranza/cliente" component={Client} />
            <Route path="/cobranza/validacion" component={ValidationUser} />
            <Route path="/cobranza/identificate" component={IdentificateUser} />
            <Route path="/cobranza/recibos" component={ReceiptsClient} />
            <Route path="/cobranza/pago" component={PaymentSummary} />
            <Route path="/cobranza/movimientos/:uuid" component={PaymentMovements} />
            <Redirect to="/cobranza/cliente" />
          </Switch>
        </Suspense>
      </div>
    </div>
  </div>
);

const AppLayout = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/app" component={App} />
      <Route path="/account" component={Account} />
    </div>
  </div>
);

const App = () => (
  <Suspense fallback={<Loading center />}>
    <Switch>
      <Route path="/app/customers" component={CustomersPage} />
      <Route path="/app/customer/:id" component={CLIENT_EXPEDIENT == 'true' ? CustomerPageTwo : CustomerPage} />
      <Route path="/app/dashboard" component={DashboardsPage} />
      <Route path="/app/invoices" component={InvoicesPage} />
      <Route path="/app/contracts" component={ContractsPage} />
      <Route path="/app/contract/detail/:uuid" component={ContractPage} />
      <Route path="/app/invoice/detail/:uuid" component={InvoicePage} />
      <Route path="/app/payments" component={PaymentsPage} />
      <Route path="/app/payment/:id" component={PaymentPage} />
      <Redirect to="/app/contracts" />
    </Switch>
  </Suspense>
);

const Account = () => (
  <Suspense fallback={<Loading center />}>
    <Switch>
      <Route path="/account/:page_name?/:retry_uuid?" component={AccountPage} />
      <Route path="/account/profile" component={AccountPage} />
      <Route path="/account/users" component={AccountPage} />
      <Route path="/account/roles" component={AccountPage} />
      <Redirect to="/app/contracts" />
    </Switch>
  </Suspense>
);

export default Router;



// WEBPACK FOOTER //
// ./src/app/Router.js